/**
 * Thrive Crafted Vans — pickup ETA override
 * Shopify location pickupTime cannot express weeks (max FIVE_OR_MORE_DAYS → "Usually ready in 5+ days").
 * Theme liquid already hardcodes 4–6 weeks; this catches drawer/cart leftovers & AJAX reloads.
 */
(function () {
  var ETA = 'Usually ready in 4–6 weeks';
  var RE = /usually ready in\s*5\+?\s*days/gi;
  var RE2 = /ready in\s*5\+?\s*days/gi;
  var scheduled = false;

  function rewriteTextNode(node) {
    var t = node.nodeValue;
    if (!t || (t.indexOf('5+') === -1 && t.indexOf('5 days') === -1 && t.indexOf('5+ days') === -1)) return;
    var n = t.replace(RE, ETA).replace(RE2, 'ready in 4–6 weeks');
    if (n !== t) node.nodeValue = n;
  }

  function walk(root) {
    if (!root) return;
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = tw.nextNode())) rewriteTextNode(n);
  }

  function run() {
    scheduled = false;
    var scope =
      document.querySelector('pickup-availability') ||
      document.querySelector('.pickup-availability-preview') ||
      document.body;
    if (!scope) return;
    // Fast bail if nothing left to fix
    var hay = scope.textContent || '';
    if (!/5\+?\s*days/i.test(hay)) return;
    walk(scope);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(run, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, product-info, [name="id"]')) {
      setTimeout(run, 400);
      setTimeout(run, 1200);
    }
  });
  if (document.documentElement) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
